const isEmpty = (values: object) => {
  return !Object.values(values).every((value) => value.length > 0);
};

export const formHasErrors = (values: object, errors: object) => {
  return Object.keys(errors).length > 0 || isEmpty(values);
};
